import type { RbacPermissionAction } from '../../types/permissions';
import type { PermissionContextValue } from '../../shared/providers/PermissionContext';

/**
 * 基幹店マスタ (SCR-001) — the 機能一覧 leaf the screen is built from
 * (基幹店マスタ | 変更履歴の表示, BA row 4). The backend maps both read routes to
 * the same code in `database/seeders/data/keilog_rbac_routes.php`.
 */
export const CLINIC_MASTER_PERMISSION = 'PERM.D5C4CB77CDD883B7';

/** The path the menu entry, the route and the route guard all use. */
export const CLINIC_MASTER_PATH = '/clinics/init';

type ClinicMasterAccess = Pick<PermissionContextValue, 'canAction'>;

/**
 * Access is the grant's answer, not the principal type's.
 *
 * Every action is read from the effective payload. Role labels and the
 * catalogue's `full`/`limited` shorthand do not decide row access: group scope,
 * assignment constraints and the principal ceiling may narrow each action.
 */
export const canViewClinicMaster = (
  access: ClinicMasterAccess,
  action: RbacPermissionAction = 'view'
): boolean => access.canAction(CLINIC_MASTER_PERMISSION, action);
